import { createContext, useContext } from "react";

export const HostContext = createContext(null);

export const useHostContext = () => {
  return useContext(HostContext);
};
